import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { AnalyticCategories } from "../constants/analytics";
import { logger } from "../logging";
import { Anchor } from "@ufginsurance/ui-kit";

const RouteNavItem = ({
  to,
  children,
  location,
  activeAtRoot,
  tabRoot,
  history,
  closeMenu,
  pushToHistory
}) => {
  pushToHistory = () => {
    history.push(to);
    if (closeMenu) closeMenu();
    logger.event({
      category: AnalyticCategories.navigation,
      action: children
    });
  };

  const path = location.pathname.toLowerCase();
  // we are active if path matches the to location
  // or path is at root and we can be active when at root.
  const isActive =
    path === to.toLowerCase() ||
    (activeAtRoot && path === "/") ||
    (tabRoot && path.toLowerCase().includes(tabRoot));

  return (
    <span className="route-item">
      <Anchor className={isActive ? "active" : ""} onClick={pushToHistory}>
        {children}
      </Anchor>
    </span>
  );
};

RouteNavItem.propTypes = {
  activeAtRoot: PropTypes.bool,
  children: PropTypes.any,
  closeMenu: PropTypes.func,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired,
  tabRoot: PropTypes.string,
  pushToHistory: PropTypes.func
};

export default withRouter(RouteNavItem);
